export * from './ionic-academy.module';
export * from './components/academy-component';
export * from './providers/academy-provider';